import {archiveFileTypeResource} from './resources/ArchiveFileTypeResource';
import {audioFileTypeResource} from './resources/AudioFileTypeResource';
import {documentFileTypeResource} from './resources/DocumentFileTypeResource';
import {imageFileTypeResource} from './resources/ImageFileTypeResource';
import {presentationFileTypeResource} from './resources/PresentationFileTypeResource';
import {sheetFileTypeResource} from './resources/SheetFileTypeResource';
import {videoFileTypeResource} from './resources/VideoFileTypeResource';
import {otherFileTypeResource} from './resources/OtherFileTypeResource';

export enum FileType {
    ARCHIVE = 'archive',
    AUDIO = 'audio',
    DOCUMENT = 'document',
    IMAGE = 'image',
    OTHER = 'other',
    PRESENTATION = 'presentation',
    SHEET = 'sheet',
    VIDEO = 'video'
}

/**
 * @name getFileTypeResource
 * @description
 * Returns the filter resource based on the selected main filter.
 */
export const getFileTypeResource = (selectedMainFilter: string) => {
    switch (selectedMainFilter) {
        case FileType.ARCHIVE:
            return archiveFileTypeResource;
        case FileType.AUDIO:
            return audioFileTypeResource;
        case FileType.DOCUMENT:
            return documentFileTypeResource;
        case FileType.IMAGE:
            return imageFileTypeResource;
        case FileType.PRESENTATION:
            return presentationFileTypeResource;
        case FileType.SHEET:
            return sheetFileTypeResource;
        case FileType.VIDEO:
            return videoFileTypeResource;
        case FileType.OTHER:
            return otherFileTypeResource;
        default:
            return [];
    }
};